import { render, staticRenderFns } from "./accessDialog.vue?vue&type=template&id=0356efbc&scoped=true"
import script from "./accessDialog.vue?vue&type=script&lang=js"
export * from "./accessDialog.vue?vue&type=script&lang=js"
import style0 from "./accessDialog.vue?vue&type=style&index=0&id=0356efbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356efbc",
  null
  
)

export default component.exports